module.exports = __webpack_public_path__ + "media/images/logo-83c40511d64510143bc3b4bf8068fbc9.svg";